import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Flex, Text, Button, Image } from '@chakra-ui/react'

import UrgentPriority from 'assets/images/urgent-priority.svg'

const ErrorPage = () => {
  const navigate = useNavigate()
  const title = 'La información no está disponible en este momento'
  const subtitle = 'Estamos trabajando para solucionarlo. Volvé a intentar más tarde.'
  const actionButton = 'Volver a la vista inicial'

  const goToDashboard = () => navigate('/dashboard')

  return (
    <Flex h='calc(80vh - 96px)' flexDir='column' align='center' justifyContent='center'>
      <Image alt='Error image' src={UrgentPriority} />
      <Text textStyle='h4Bold' p={2}>{title}</Text>
      <Text textStyle='bodyLg' pb={8}>{subtitle}</Text>
      <Button data-testid='actionButton' variant='primary-text' onClick={goToDashboard}>
        <Text textStyle='bodyLgBold'>{actionButton}</Text>
      </Button>
    </Flex>
  )
}

export default ErrorPage
